// extracted by mini-css-extract-plugin
export default {"wrp":"DocumentVersions_wrp__oh30B","title":"DocumentVersions_title__pF1Yv"};